import React from "react";
import moment from "moment";
import "./scheduleStyle.css";
import CustomDateTimePicker from "../../DateTimePicker/dateTimePicker";
import FormInput from "../Input/formInput";

const CommonTimeSlotForAllWeek = ({ setCommonTimeSlots, commonTimeSlots, isProfilePage = false }) => {
  const timeSlots = Array.isArray(commonTimeSlots)
    ? commonTimeSlots
    : [{ from: "", to: "", description: "" }];

  const handleCommonTimeSlotChange = (index, field, value) => {
    const formattedValue = moment.isMoment(value) ? value.format("HH:mm") : value;
    const newTimeSlots = timeSlots.map((slot, i) =>
      i === index ? { ...slot, [field]: formattedValue } : slot
    );
    setCommonTimeSlots(newTimeSlots);
  };

  const handleDescriptionChange = (index, value) => {
    const newTimeSlots = timeSlots.map((slot, i) =>
      i === index ? { ...slot, description: value } : slot
    );
    setCommonTimeSlots(newTimeSlots);
  };

  const handleAddTimeSlot = () => {
    setCommonTimeSlots([...timeSlots, { from: "", to: "", description: "" }]);
  };

  const handleDeleteTimeSlot = (index) => {
    if (timeSlots.length > 1) {
      setCommonTimeSlots(timeSlots.filter((_, i) => i !== index));
    }
  };

  return (
    <div className="common-time-slots-container">
      {timeSlots.map((slot, index) => (
        <div
          className={`row align-items-center mb-2 ${isProfilePage ? "gx-3" : ""}`}
          key={index}
        >
          {isProfilePage && (
            <div className="col-3 d-flex align-items-center">
              <FormInput
                placeHolder="Services Name"
                type="text"
                value={slot.description || ""}
                onchange={(e) => handleDescriptionChange(index, e.target.value)}
                width="100%"
                className="form-control align-input"
              />
            </div>
          )}

          <div className={isProfilePage ? "col-3 d-flex align-items-center" : "col-3"}>
            <CustomDateTimePicker
              label="Start Time"
              value={slot.from ? moment(slot.from, "HH:mm") : null}
              mode="time"
              onChange={(time) => handleCommonTimeSlotChange(index, "from", time)}
              ampm={true}
              placeholder="Select time"
            />
          </div>

          <div
            className={isProfilePage ? "col-1 text-center d-flex align-items-center justify-content-center" : "col-2 text-center"}
          >
            <span className={isProfilePage ? "fw-bold" : ""}>to</span>
          </div>

          <div className={isProfilePage ? "col-3 d-flex align-items-center" : "col-5"}>
            <CustomDateTimePicker
              label="End Time"
              value={slot.to ? moment(slot.to, "HH:mm") : null}
              mode="time"
              onChange={(time) => handleCommonTimeSlotChange(index, "to", time)}
              ampm={true}
              placeholder="Select time"
            />
          </div>

          <div
            className={isProfilePage ? "col-1 d-flex align-items-center justify-content-center" : "col-1 d-flex align-items-center justify-content-center"}
          >
            {index !== 0 && (
              <button
                className="btn btn-link p-0 text-danger"
                onClick={() => handleDeleteTimeSlot(index)}
                type="button"
              >
                <span className="fa fa-times text-danger"></span>
              </button>
            )}
          </div>

          {/* Add Button (Only for Last Slot) */}
          <div
            className={isProfilePage ? "col-1 d-flex align-items-center justify-content-center" : "col-1 d-flex align-items-center justify-content-center"}
          >
            {index === timeSlots.length - 1 && (
              <button
                className="btn btn-link p-0 text-primary"
                onClick={handleAddTimeSlot}
                type="button"
              >
                <span className="icon-plus text-primary"></span>
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CommonTimeSlotForAllWeek;